import {AssertionUtils} from '@vdw/angular-component-library';
import {ProductionOrderCarpetForPlanningOrder} from './carpet/production-order-carpet-for-planning-order';
import {PlanningOrderData} from './planning-order-data';
import {ProductionOrderTuftingForPlanningOrder} from './tufting/production-order-tufting-for-planning-order';
import {ProductionOrderWeavingForPlanningOrder} from './weaving/production-order-weaving-for-planning-order';

export class NeedsAttentionItem {
  private _planningOrderId: number;
  private _orderData: PlanningOrderData;

  public constructor(orderData: PlanningOrderData, planningOrderId: number) {
    this._orderData = orderData;
    this._planningOrderId = planningOrderId;
  }

  public get productionOrderCarpet(): ProductionOrderCarpetForPlanningOrder {
    if (!this.isCarpetOrder) {
      return undefined;
    }
    return this._orderData as ProductionOrderCarpetForPlanningOrder;
  }

  public get productionOrderWeaving(): ProductionOrderWeavingForPlanningOrder {
    if (!this.isWeavingOrder) {
      return undefined;
    }
    return this._orderData as ProductionOrderWeavingForPlanningOrder;
  }

  public get productionOrderTufting(): ProductionOrderTuftingForPlanningOrder {
    if (!this.isTuftingOrder) {
      return undefined;
    }
    return this._orderData as ProductionOrderTuftingForPlanningOrder;
  }

  public get planningOrderId(): number {
    return this._planningOrderId;
  }

  public get isCarpetOrder(): boolean {
    return this._orderData instanceof ProductionOrderCarpetForPlanningOrder;
  }

  public get isWeavingOrder(): boolean {
    return this._orderData instanceof ProductionOrderWeavingForPlanningOrder;
  }

  public get isTuftingOrder(): boolean {
    return this._orderData instanceof ProductionOrderTuftingForPlanningOrder;
  }

  public static fromJSON(jsonData: any): NeedsAttentionItem {
    return new NeedsAttentionItem(this.parseOrderDataJson(jsonData), jsonData.planningOrderId);
  }

  private static parseOrderDataJson(jsonData: any): PlanningOrderData {
    if (AssertionUtils.isNullOrUndefined(jsonData.productionOrderLiteId)) {
      return ProductionOrderCarpetForPlanningOrder.fromNeedsAttentionItemJSON(jsonData);
    }

    if (!AssertionUtils.isNullOrUndefined(jsonData.tuftProduct)) {
      return ProductionOrderTuftingForPlanningOrder.fromNeedsAttentionItemJSON(jsonData);
    }

    return ProductionOrderWeavingForPlanningOrder.fromNeedsAttentionItemJSON(jsonData);
  }
}
